<template>
    <FilterLayout title="Services">
        <div class="dealer-locator__service-filter">
            <label 
                v-for="(label, service) in services"
                :key="`service:${service}`"

                class="dealer-locator__service-filter--label" :for="`service-${service}`"
            >
                <input 
                    class="form-input" 
                    type="checkbox" 
                    name="services[]" 
                    :value="service" 
                    :id="`service-${service}`"

                    :checked="isSelected(service)"
                    @input="toggle(service)"
                />
                <span>{{ label }}</span>
            </label>
        </div>
    </FilterLayout>
</template>

<script>
    import { defineComponent } from "vue";
    import FilterLayout from "./Filter.vue";
    import { mapGetters, mapActions } from "vuex";

    export default defineComponent({
        name: 'Service',

        components: {
            FilterLayout
        },

        methods: {
            ...mapActions({
                toggle: 'DealerData/toggleService',
            }),
        },

        computed: {
            ...mapGetters({
                services: 'DealerData/filterableServices',
                isSelected: 'DealerData/isServiceSelected'
            })
        }
    })
</script>